<template>
    <section class="mt-4 md:mt-8 lg:mt-16 xl:mt-20">
        <div class="relative xl:max-w-5xl lg:max-w-[80%] md:max-w-[98%] sm:max-w-[85%] max-w-[95%] w-full mx-auto min-h-64 rounded-[2.5rem] max-lg:bg-center max-md:bg-none flex flex-col py-9 md:py-19 px-3 lg:px-0 bg-[url('@/assets/images/stellar/talk-to-us-bg.svg')] bg-cover items-stretch">
            <!-- Title and subtitle centered at the top of the section -->
            <div class="w-full text-center mb-4">
                <h2 class="font-inter xl:text-4xl/10 md:text-2xl text-xl font-bold capitalize bg-clip-text text-transparent bg-gradient-to-r from-slate-50/60 via-slate-50 to-slate-50/60 mb-1">{{ $t('contact_us_title') }}</h2>
                <h3 class="font-inter text-sm/5 font-normal text-slate-300 mb-2">{{ $t('contact_us_subtitle') }}</h3>
            </div>
            <div class="flex flex-wrap lg:w-11/12 md:w-[95%] w-full mx-auto flex-1 ">
                <!-- Info panel left -->
                <div class="md:w-1/2 w-full p-2 flex flex-col gap-4 justify-center max-w-xl mx-auto h-full flex-grow">
                    <div class="from-gray-700 to-gray-700/25 rounded-2xl  p-4 mb-2 flex-1 flex flex-col justify-center">
                        <h3 class="text-base font-semibold text-indigo-300 mb-1">{{ $t('contact_us_email_title') }}</h3>
                        <p class="text-gray-400 text-xs mb-1">{{ $t('contact_email_text') }}</p>
                        <p class="text-gray-200 text-sm flex flex-row items-center gap-2 justify-start leading-tight">
                            <span class="w-5 h-5 text-indigo-400 flex-shrink-0 flex items-center justify-center"><font-awesome-icon icon="fa-solid fa-at" /></span>
                            <span class="align-middle">info@protostars.ai</span>
                        </p>
                    </div>
                    <div class="from-gray-700 to-gray-700/25 rounded-2xl  p-4 flex-1 flex flex-col justify-center">
                        <h3 class="text-base font-semibold text-indigo-300 mb-1">{{ $t('contact_address_title') }}</h3>
                        <p class="text-gray-400 text-xs mb-1">{{ $t('contact_address_text') }}</p>
                        <p class="text-gray-200 text-sm flex flex-row items-center gap-2 justify-start leading-tight">
                            <span class="w-5 h-5 text-indigo-400 flex-shrink-0 flex items-center justify-center"><font-awesome-icon icon="fa-solid fa-location-dot" /></span>
                            <span class="align-middle" v-html="$t('contact_address')"></span>
                        </p>
                    </div>
                </div>
                <!-- Form panel right -->
                <div class="md:w-1/2 w-full py-2 lg:px-8 md:px-4 px-1  flex flex-col justify-center max-w-lg mx-auto h-full flex-grow">
                    <Vueform v-model="formData" validate-on="change|step" class="vueFormContainer h-full flex flex-col justify-center"
                        :endpoint="false" ref="contactUsFormRef" @submit="submitContactUs($event)"
                        :display-messages="false" :display-errors="false">
                        <TextElement name="sender_name" :placeholder="$t('contact_us_type_name')" rules="required" />
                        <TextElement name="sender_email" input-type="email" :placeholder="$t('contact_us_type_email')" rules="required|email" />
                        <TextareaElement name="body" :placeholder="$t('contact_us_message')" :autogrow="true" rows="3" />
                        <ButtonElement name="button" :submits="true" full :loading="is_loading"
                            button-class="bg-gradient-to-b from-gray-100 to-gray-200 rounded-lg text-center !border-gray-100 !text-gray-800 text-md font-bold leading-normal mt-2">
                            {{ $t("btn_submit") }}
                        </ButtonElement>
                    </Vueform>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import axios from 'axios'

export default {
    name: 'ContactUsSection',
    data() {
        return {
            name: null,
            email: null,
            message: null,
            is_loading: false,
            formData: {
            },
            result:null
        }
    },
    mounted() {
        console.log(this.$refs.contactUsFormRef)
        // axios.get('https://ipinfo.io/json').then(response => {
        //     console.log(response.data)
        // })


        axios
            .get("https://ipinfo.io/json", {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            })
            .then(async (response) => {
                console.log("response", response);

               this.result = response.data
            })
            .catch((error) => {
                console.log("Error", error)

            });


    },
    methods: {
        onSubmit() {
            // console.log("submit")
            this.is_loading = true

            let requestData = {
                "sender_name": this.name,
                "sender_email": this.email,
                "body": this.message
            }
            axios
                .post("common/send-contact-us-form", requestData, {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        client: "PROTOSTARS",
                    },
                })
                .then((response) => {
                    console.log(response);
                    this.$swal({
                        // title: "Title",
                        text: "Thank you for your submission, one of our team will reply back to you shortly",
                        icon: "success",
                        confirmButtonColor: '#03989E',
                        customClass: {
                            confirmButton: "btn btn-primary "
                        },
                        // timer: 3000,
                    }).then((r) => {
                        // console.log(r.value);
                        this.name = ""
                        this.email = ""
                        this.message = ""
                        this.is_loading = false
                    });


                })
                .catch((error) => {
                    // console.log(error);
                    this.$swal({
                        // title: "Title",
                        text: error.response.data.error
                            ? error.response.data.error
                            : error.response.data.message,
                        icon: "error",
                        confirmButtonColor: '#03989E',
                        customClass: {
                            confirmButton: "btn btn-primary "
                        },
                        // timer: 3000,
                    }).then((r) => {
                        // console.log(r.value);
                        this.is_loading = false
                    });
                });
        },
        submitContactUs(e) {
            console.log("in submit contact us")
            console.log(this.formData)
            console.log(this.$refs.contactUsFormRef)
            // e.preventDefault() 
            this.is_loading = true
            axios
                .post("common/send-contact-us-form", this.formData, {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        client: "PROTOSTARS",
                    },
                })
                .then((response) => {
                    console.log(response);
                    this.$swal({
                        // title: "Title",
                        text: this.$t('contact_us_success_message'),
                        icon: "success",
                        confirmButtonColor: '#55B3F7',
                        customClass: {
                            confirmButton: "bg-gray-100  rounded-lg text-center !border-gray-100 !text-gray-800 text-md font-medium leading-normal "
                        },
                        color: "#F3F4F6",

                        background: "#374151"
                        // timer: 3000,
                    }).then((r) => {
                        // console.log(r.value);
                        // this.formData = {}
                        this.$refs.contactUsFormRef.reset()
                        this.is_loading = false
                    });


                })
                .catch((error) => {
                    // console.log(error);
                    this.$swal({
                        // title: "Title",
                        text: error.response.data.error
                            ? error.response.data.error
                            : error.response.data.message,
                        icon: "error",
                        confirmButtonColor: '#03989E',
                        customClass: {
                            confirmButton: "btn btn-primary "
                        },
                        // timer: 3000,
                    }).then((r) => {
                        // console.log(r.value);
                        this.is_loading = false
                    });
                });

        }
    }
}
</script>